<template>
  <div class="canvas-strings">
    <canvas class="strings" ref="stringsCanvas"></canvas>
  </div>
</template>
<script>
import animMixin from "@/assets/js/animMixin.js";
export default {
  name: "canvasStrings",
  props: {
    animProg: Boolean
  },
  mixins: [animMixin],

  data() {
    return {
      strings_cx: null,
      cx5: null,
      numStrings: 6,
      perlin: null,
      dmin: -0.5,
      dmax: 0.5,
      offmin: 0,
      offmax: 1000,
      strings: [],
      w: null,
      h: null,
      stringsAnim: false,
      ticker: 0,
      anStrings: 0
    };
  },
  mounted() {
    // window.addEventListener("resize", this.canvasResize);
    this.initCanvas();
    this.initPerlin();
    this.createStrings();


    // this.performAnim();
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.canvasResize);
    this.anStrings = 0;
    this.stringsAnim = false;
  },
  methods: {
    canvasResize() {
      this.strings = [];
      this.initCanvas();
      this.createStrings();
    },
    initPerlin() {
      this.perlin = new this.perlinNoise();
    },
    makeNoise(offset) {
      let s = this.perlin.getVal(offset);
      return s;
    },

    initCanvas() {
      this.strings_cx = this.$refs.stringsCanvas;
      this.strings_cx.width = this.$refs.stringsCanvas.parentElement.clientWidth;
      this.strings_cx.height = this.$refs.stringsCanvas.parentElement.clientHeight;
      this.cx5 = this.strings_cx.getContext("2d");
      this.cx5.globalCompositeOperation = "hard-light";
      this.w = this.strings_cx.width;
      this.h = this.strings_cx.height;
    },
    newString() {
      let str = {
        x: this.randomNum(0, this.w, true),
        y: this.randomNum(0, this.h, true),
        dx: this.randomNum(this.dmin, this.dmax, true),
        dy: this.randomNum(this.dmin, this.dmax, true),
        offset: {
          x1: this.randomNum(this.offmin, this.offmax, true),
          x2: this.randomNum(this.offmin, this.offmax, true),
          x3: this.randomNum(this.offmin, this.offmax, true),
          y1: this.randomNum(this.offmin, this.offmax, true),
          y2: this.randomNum(this.offmin, this.offmax, true),
          y3: this.randomNum(this.offmin, this.offmax, true)
        },
        cp1x: this.randomNum(0, this.w, true),
        cp1y: this.randomNum(0, this.h, true),
        cp2x: this.randomNum(0, this.w, true),
        cp2y: this.randomNum(0, this.h, true),
        epx: this.randomNum(0, this.w, true),
        epy: this.randomNum(0, this.h, true),
        cp1xd: this.p5map(this.makeNoise(1000), 0, 1, 0, this.w),
        cp1yd: this.p5map(this.makeNoise(500), 0, 1, 0, this.h),
        cp2xd: this.p5map(this.makeNoise(700), 0, 1, 0, this.w),
        cp2yd: this.p5map(this.makeNoise(900), 0, 1, 0, this.h)
      };
      return str;
    },
    updateString(i) {
      this.strings[i].x += this.strings[i].dx;
      this.strings[i].y += this.strings[i].dy;
      this.strings[i].cp2xd = this.p5map(
        this.makeNoise(this.strings[i].offset.x3),
        0,
        1,
        0,
        this.w
      );
      this.strings[i].cp2yd = this.p5map(
        this.makeNoise(this.strings[i].offset.y3),
        0,
        1,
        0,
        this.h
      );
      this.strings[i].cp1xd = this.p5map(
        this.makeNoise(this.strings[i].offset.x2),
        0,
        1,
        0,
        this.w
      );
      this.strings[i].cp1yd = this.p5map(
        this.makeNoise(this.strings[i].offset.y2),
        0,
        1,
        0,
        this.h
      );
      this.strings[i].cp2x = this.strings[i].cp2xd;
      this.strings[i].cp2y = this.strings[i].cp2yd;
      this.strings[i].cp1x = this.strings[i].cp1xd;
      this.strings[i].cp1y = this.strings[i].cp1yd;
      this.strings[i].epx = this.p5map(
        this.makeNoise(this.strings[i].offset.x1),
        0,
        1,
        0,
        this.w
      );
      this.strings[i].epy = this.p5map(
        this.makeNoise(this.strings[i].offset.y2),
        0,
        1,
        0,
        this.h
      );
      this.strings[i].offset.x1 += 0.001;
      this.strings[i].offset.y1 += 0.001;
      this.strings[i].offset.x2 += 0.001;
      this.strings[i].offset.y2 += 0.001;
    },

    createStrings() {
      for (let i = 0; i < this.numStrings; i++) {
        let s = this.newString();
        this.strings.push(s);
      }
      //console.log(this.strings);
    },
    randomizeLineDash(){

    },

    renderString(i) {
      let grad = this.cx5.createLinearGradient(0, 0, 0, this.h);
      grad.addColorStop(0, "green");
      grad.addColorStop(1, "white");


      this.cx5.strokeStyle = '#00bdb6';
      this.cx5.beginPath();
      this.cx5.setLineDash([2, 50]);
      this.cx5.moveTo(this.strings[i].x, this.strings[i].y);
      this.cx5.bezierCurveTo(
        this.strings[i].cp1x,
        this.strings[i].cp1y,
        this.strings[i].cp2x,
        this.strings[i].cp2y,
        this.strings[i].epx,
        this.strings[i].epy
      );
      this.cx5.lineWidth = 2;
      //pattern, can be more than 2 entries
      this.cx5.fillStyle = "rgba(0,0,0,0)";
      this.cx5.fill();
      this.cx5.stroke();
    },

    performAnim() {
      this.cx5.clearRect(0, 0, this.w, this.h);
      if (this.stringsGo === false) return;

      for (var i = 0; i < this.numStrings; i++) {
        this.updateString(i);
        this.renderString(i);
      }

      requestAnimationFrame(this.performAnim);
    }
  },
  computed: {
    stringsGo() {
      return this.anStrings !== 0 ? true : false;
    }
  },
  watch: {
    stringsGo(newval) {
      if (newval === true) {
        requestAnimationFrame(this.performAnim);
      } else {
        cancelAnimationFrame(this.performAnim);
      }
    },
    animProg(newval) {
      if (newval) {
        this.anStrings = 1;
      }
      else {
        // active fade in
        this.anStrings = 0;
      }


      // onsole.log(this.anStrings);
    }
  }
};
</script>
<style lang="scss">
.canvas-strings {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 1;


  .strings {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
